const iconMap = {
  home: <ion-icon name="home-outline"></ion-icon>,
  chart: <ion-icon name="stats-chart-outline"></ion-icon>,
  person: <ion-icon name="person-outline"></ion-icon>,
  people: <ion-icon name="people-outline"></ion-icon>,
  storefront: <ion-icon name="storefront-outline"></ion-icon>,
  cart: <ion-icon name="cart-outline"></ion-icon>,
  documentText: <ion-icon name="document-outline"></ion-icon>,
  analytics: <ion-icon name="analytics-outline"></ion-icon>,
  settings: <ion-icon name="settings-outline"></ion-icon>,
  helpCircle: <ion-icon name="help-circle-outline"></ion-icon>,
  iceCream: <ion-icon name="ice-cream-outline"></ion-icon>,
  rocket: <ion-icon name="rocket-outline"></ion-icon>,
  people: <ion-icon name="people-outline"></ion-icon>,
  pricetag: <ion-icon name="pricetag-outline"></ion-icon>,
  reorder: <ion-icon name="reorder-four-outline"></ion-icon>,
  logout: <ion-icon name="log-out-outline"></ion-icon>,
  eye: <ion-icon name="eye-outline"></ion-icon>,
  trash: <ion-icon name="trash-outline"></ion-icon>,
  chevronBack: <ion-icon name="chevron-back-outline"></ion-icon>,
  chevronForward: <ion-icon name="chevron-forward-outline"></ion-icon>,
  hammer: <ion-icon name="hammer-outline"></ion-icon>,
  add: <ion-icon name="add-outline"></ion-icon>,
  edit: <ion-icon name="brush-outline"></ion-icon>,
  trendingUp: <ion-icon name="trending-up-outline"></ion-icon>,
  chevronDown: <ion-icon name="chevron-down-outline"></ion-icon>,
  appsOutline: <ion-icon name="grid-outline"></ion-icon>,
  eyeOff: <ion-icon name="eye-off-outline"></ion-icon>,
  lock: <ion-icon name="lock-closed-outline"></ion-icon>,
  menu: <ion-icon name="reorder-four-outline"></ion-icon>,
  close: <ion-icon name="close-outline"></ion-icon>,
  document: <ion-icon name="document-outline"></ion-icon>,
  download: <ion-icon name="download-outline"></ion-icon>,
  time: <ion-icon name="time-outline"></ion-icon>,
  terminal: <ion-icon name="desktop-outline"></ion-icon>,
  pause: <ion-icon name="pause-outline"></ion-icon>,
  play: <ion-icon name="play-outline"></ion-icon>,
  reader: <ion-icon name="reader-outline"></ion-icon>,
  copy: <ion-icon name="copy-outline"></ion-icon>,
  // SVG embebido: evita que la acción de NC dependa de que Ionicons cargue desde un CDN.
  creditNote: (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M5 2.5h8l4 4V21.5H5z" />
      <path d="M13 2.5v4h4" />
      <path d="m8.5 12 5 5m0-5-5 5" />
    </svg>
  ),
  salesReturn: <ion-icon name="return-down-back-outline"></ion-icon>,
  bagHandle: <ion-icon name="bag-handle-outline"></ion-icon>,
  printer: <ion-icon name="print-outline"></ion-icon>,
  business: <ion-icon name="business-outline"></ion-icon>,
  invoice: <ion-icon name="document-text-outline"></ion-icon>,
  fav_add: <ion-icon name="add-outline" style={{ fontSize: 24 }}></ion-icon>,
  checkmarkDone: <ion-icon name="checkmark-done-outline"></ion-icon>,
  restaurant: <ion-icon name="restaurant-outline"></ion-icon>,
  checkmark: <ion-icon name="checkmark-outline"></ion-icon>,
  warning: <ion-icon name="warning-outline"></ion-icon>,
  money: <ion-icon name="cash-outline"></ion-icon>,
  location: <ion-icon name="location-outline"></ion-icon>,
  question: <ion-icon name="help-circle-outline"></ion-icon>,
  flash: <ion-icon name="flash-outline"></ion-icon>,
  megaphone: <ion-icon name="megaphone-outline"></ion-icon>,
  mail: <ion-icon name="mail-outline"></ion-icon>,
  card: <ion-icon name="card-outline"></ion-icon>,
  save: <ion-icon name="save-outline"></ion-icon>,
  cloudUpload: <ion-icon name="cloud-upload-outline"></ion-icon>,
  refresh: <ion-icon name="refresh-outline"></ion-icon>,
  globeOutline: <ion-icon name="globe-outline"></ion-icon>,
  phonePortrait: <ion-icon name="phone-portrait-outline"></ion-icon>,
  chatbubbles: <ion-icon name="chatbubbles-outline"></ion-icon>,
  bug: <ion-icon name="bug-outline"></ion-icon>,
  school: <ion-icon name="school-outline"></ion-icon>,
  moreVertical: <ion-icon name="ellipsis-vertical-outline"></ion-icon>
};

export const getIcon = (iconName) => {
  return iconMap[iconName] || iconMap['home'];
};
